import $ from "jquery";

class CalcSelantesAdesivos {

    constructor() {

        console.log('Calculo Selantes Adesivos');

        
        function solicitarInformacoes() {
            document.querySelector('.modal-informacoes').classList.add('show');
            $(".box-solicitar-informacoes").fadeIn();
            $(".bg").fadeIn();
            $(".message").attr('placeholder','Quero informações sobre Rejunte Infinity');
            return false;
        }
        $("#solicitarInformacore").on('click', solicitarInformacoes);
        
        let btnorcamento = document.querySelector("#solicitarOrcamento");

        if (btnorcamento) {
            btnorcamento.addEventListener('click', function (event) {
                event.preventDefault();
                document.querySelector(".modal-orcamento").classList.add('show');
            });
        }


        /* global calculoSelantesAdesivosParams */
        (function (window, document, undefined) {
            class CalculoSelantesAdesivosForm {
                constructor(form) {
                    const self = this;

                    self.form = form;
                    self.products = form.querySelectorAll('[name="product"]');

                    form.on = (type, selectors, data = undefined, listener = undefined) => {
                        let fListener;
                        if ('function' === typeof data) {
                            listener = data;
                            if ('object' === typeof selectors) {
                                data = selectors;
                                selectors = undefined;
                            }
                        } else if ('function' === typeof selectors) {
                            listener = selectors;
                        }
                        fListener = listener;
                        if (undefined !== data) {
                            fListener = (event) => {
                                event.dataData = data;
                                listener(event);
                            };
                        }
                        if ('string' === typeof selectors) {
                            form.querySelectorAll(selectors).forEach((target) => {
                                target.addEventListener(type, fListener, false);
                            });
                        } else {
                            form.addEventListener(type, fListener, false);
                        }
                    };

                    'width,height,length'.split(',').forEach((dimension) => {
                        const input = form.querySelector(`[name="${dimension}"]`);
                        const label = input.parentNode.querySelector('label');
                        window.sessionStorage.setItem(dimension, label.innerHTML);
                    });

                    form.on('change', '[name="product"]', { self }, self.onProductChange);
                    form.on('change', '[name="joint"]', { self }, self.onJointChange);
                    form.on('submit', { self }, self.onCalculate);

                    // form.on( 'input', { self }, self.resetResult );

                    // form.on( 'click', '.print', { self }, self.onPrint );
                    // form.on( 'click', '.requestQuote', { self }, self.onRequestQuoteShow );

                    // const requetQuoteForm = document.getElementById( 'requestQuote' );
                    // requetQuoteForm.addEventListener(
                    //     'submit',
                    //     ( event ) => {
                    //         event.dataData = { self };
                    //         self.onRequestQuoteSend( event );
                    //     }
                    // );
                }
            }

            CalculoSelantesAdesivosForm.prototype.onCalculate = (event) => {
                const self = event.dataData.self;

                const data = self.formData(self);

                const width = data.width;
                const height = data.height;
                const length = data.length;
                const joint = data.joint;
                const loss = data.loss;

                data.volume = width * height * length * joint * (1 + loss);
                data.volume = Math.round(data.volume);
                data.quantity = data.volume / data.product.volume;
                data.quantity = Math.round(data.quantity * 10) / 10;
                data.quantity = Math.ceil(data.quantity);

                self.result(self, data);

                self.fetch(self.form.action, self.productData(data));
                event.preventDefault();
            };

            CalculoSelantesAdesivosForm.prototype.onJointChange = (event) => {
                const self = event.dataData.self;
                const form = self.form;
                const radio = event.target;
                const joint = parseInt(radio.value);
                if (5 === joint) {
                    form.querySelectorAll('[data-joint5]').forEach((span) => {
                        span.textContent = span.dataset.joint5;
                    });
                } else {
                    'width,height,length'.split(',').forEach((dimension) => {
                        const input = form.querySelector(`[name="${dimension}"]`);
                        const label = input.parentNode.querySelector('label');
                        label.innerHTML = window.sessionStorage.getItem(dimension);
                    });
                }

                self.products.forEach((product) => {
                    const label = product.parentNode;
                    label.classList.remove('d-none');
                    if (!label.classList.contains(`joint${joint}`)) {
                        label.classList.add('d-none');
                        if (self.product(self) && self.product(self).value === product.value) {
                            product.checked = false;
                            product.change();
                        }
                    }
                });
            };

            CalculoSelantesAdesivosForm.prototype.urlEncoded = (data) => {
                const urlEncoded = [];
                const encode = (s) => {
                    return encodeURIComponent(s).replace(/%20/g, '+');
                };
                Array.from(Object.entries(data)).forEach((pair) => {
                    if ('string' === typeof pair[0]) {
                        urlEncoded.push(encode(pair[0]) + '=' + encode(pair[1]));
                    }
                });
                return urlEncoded.join('&');
            };

            CalculoSelantesAdesivosForm.prototype.resetResult = (event) => {
                const self = event.dataData.self;
                self.setText('volume', '');
                self.setText('quantity', '');
                self.hide('.result');
            };

            CalculoSelantesAdesivosForm.prototype.onProductChange = (event) => {
                const self = event.dataData.self;

                self.resetProducts(self.products);

                self.hide('.result');

                const product = self.product(self);
                if (product) {
                    const joints = self.form.querySelectorAll('[name="joint"]');
                    joints.forEach((joint) => {
                        const column = joint.parentNode.parentNode;
                        column.classList.remove('d-none');
                        const productLabel = product.parentNode;
                        if (!productLabel.classList.contains(`joint${joint.value}`)) {
                            column.classList.add('d-none');
                        }
                    });                    

                    const applicator = JSON.parse(product.dataset.applicator);

                    const applicatorTd = document.querySelector(`[data-applicator]:not(input)`);
                    const applicatorTr = applicatorTd.parentNode;
                    const applicatorTitle = document.querySelector('.title-applicator')

                    let tdToRemove = applicatorTd.nextElementSibling;

                    while (tdToRemove) {
                        applicatorTr.removeChild(tdToRemove);
                        tdToRemove = applicatorTd.nextElementSibling;
                    }

                    applicatorTitle.style.display = 'block';

                    if (Array.isArray(applicator) && applicator.length) {

                        applicatorTd.style.display = 'table-cell';
                        
                        applicator.forEach((item) => {
                            const newApplicatorTd = applicatorTd.cloneNode(true); // clona a td original
                            
                            newApplicatorTd.removeAttribute('data-applicator')

                            newApplicatorTd.querySelector('img').src = item.image;
                            newApplicatorTd.querySelector('span strong').textContent = item.name;
                            
                            console.log(newApplicatorTd)
                            
                            applicatorTr.append(newApplicatorTd)
                        });
                        
                        applicatorTd.style.display = 'none';

                    } else {

                        applicatorTitle.style.display = 'none';
                        applicatorTr.append(applicatorTd)
                        
                    }
                }
            };

            CalculoSelantesAdesivosForm.prototype.resetProducts = (products) => {
                products.forEach((product) => {
                    const label = product.parentNode.parentNode;
                    const thumb = label.querySelector('figure img');
                    thumb.parentNode.classList.remove('active');
                });
            };

            CalculoSelantesAdesivosForm.prototype.product = (self) => {
                return self.form.querySelector('[name="product"]:checked');
            };

            CalculoSelantesAdesivosForm.prototype.label = (self) => {
                const product = self.product(self);
                return product.parentNode;
            };

            CalculoSelantesAdesivosForm.prototype.thumb = (self) => {
                const label = self.label(self);
                return label.querySelector('img');
            };

            CalculoSelantesAdesivosForm.prototype.productData = (data) => {                
                const product = data.product;            
                data.product = `${product.id}-${product.packing}-${product.volume}`;
                data.joint *= 10;
                data.loss *= 100;
                delete data.volume;
                delete data.quantity;
                return data;
            };

            CalculoSelantesAdesivosForm.prototype.fetch = (url, data) => {
                // const request = new XMLHttpRequest();
                // request.open( 'POST', url );
                // request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8' );
                // request.send( data );

                let dataCalc = new FormData();

                dataCalc.append('action', 'send_mail_calc_selantes');
                dataCalc.append('email', data.email);
                dataCalc.append('product', data.product);
                dataCalc.append('joint', data.joint);
                dataCalc.append('width', data.width);
                dataCalc.append('height', data.height);
                dataCalc.append('length', data.length);
                dataCalc.append('loss', data.loss);

                fetch(ajaxurl, {
                    method: 'POST',
                    body: dataCalc
                })
                    .then(response => {
                        response.json()
                            .then(data => {
                                console.log(data);
                            });
                    });
            };

            CalculoSelantesAdesivosForm.prototype.formData = (self) => {
                const data = Object.fromEntries(new FormData(self.form).entries());
                const output = /^(\d+)-(.*)-(\d+)$/.exec(data.product);
                const product = {
                    id: parseInt(output[1]),
                    packing: output[2],
                    volume: parseInt(output[3]),
                };
                const radio = self.product(self);
                product.title = radio.parentNode.querySelector('span').textContent;
                const regex = new RegExp(`\\s*-\\s*${product.packing}$`);
                product.title = product.title.replace(regex, '');
                data.product = product;
                data.joint = parseInt(data.joint) / 10;
                data.width = parseInt(data.width);
                data.height = parseInt(data.height);
                data.length = parseInt(data.length);
                data.loss = parseInt(data.loss) / 100;
                return data;
            };

            CalculoSelantesAdesivosForm.prototype.setThumb = (self) => {
                const thumb = self.thumb(self);
                const printThumb = document.querySelector('[data-product-thumb]');
                printThumb.src = thumb.src;
                printThumb.width = thumb.width;
                printThumb.height = thumb.height;
            };

            CalculoSelantesAdesivosForm.prototype.setText = (data, value) => {
                document.querySelectorAll(`[data-${data}]`).forEach((node) => {
                    node.textContent = value;
                });
            };

            CalculoSelantesAdesivosForm.prototype.setValue = (data, value) => {
                document.querySelectorAll(`[data-${data}]`).forEach((node) => {
                    node.value = value;
                });
            };

            CalculoSelantesAdesivosForm.prototype.result = (self, values) => {
                //self.setThumb( self );

                self.setText('width', values.width);
                self.setText('height', values.height);
                self.setText('length', values.length);
                self.setText('loss', values.loss * 100);
                self.setText('volume', values.volume);
                self.setText('quantity', values.quantity);
                self.setValue('request-quote-quantity', Math.ceil(values.quantity));
                self.setValue('request-quote-email', values.email);

                'width,height,length'.split(',').forEach((dimension) => {
                    const input = self.form.querySelector(`[name="${dimension}"]`);
                    const label = input.parentNode;
                    self.setText(`${dimension}-label`, label.textContent);
                });

                self.show('.result');
            };

            CalculoSelantesAdesivosForm.prototype.hide = (selectors) => {
                document.querySelectorAll(selectors).forEach((node) => {
                    node.classList.add('d-none');
                });
            };

            CalculoSelantesAdesivosForm.prototype.show = (selectors) => {
                document.querySelectorAll(selectors).forEach((node) => {
                    if (node.classList.contains('d-none')) {
                        node.classList.remove('d-none');
                    } else {
                        node.style.display = 'block';
                    }
                });
            };

            CalculoSelantesAdesivosForm.prototype.onPrint = (event) => {
                const self = event.dataData.self;

                event.preventDefault();

                let selectors = '.infos-top,header,.sidenav,.topo.topo-small,.bg-white,footer';
                selectors = selectors.split(',').map((selector) => {
                    return '.master-wrap ' + selector;
                });

                self.hide(selectors);

                self.show('.show-print');

                setTimeout(() => {
                    window.print();

                    self.show(selectors);

                    self.hide('.show-print');
                }, 1000);

                event.preventDefault();
            };

            CalculoSelantesAdesivosForm.prototype.onRequestQuoteShow = (event) => {
                const self = event.dataData.self;

                self.show('.box-solicitar-orcamento,.bg');

                return false;
            };

            CalculoSelantesAdesivosForm.prototype.onRequestQuoteSend = (event) => {
                const self = event.dataData.self;
                const form = event.target;
                event.preventDefault();
                const data = Object.fromEntries(new FormData(form).entries());
                const returnRequestQuote = document.getElementById('retorno-orcamento-calculo');
                returnRequestQuote.innerText = calculoSelantesAdesivosParams.loading;
                const request = new XMLHttpRequest();
                request.open('POST', form.action);
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                request.onreadystatechange = function () {
                    if ('' !== request.responseText) {
                        const ret = JSON.parse(request.responseText);
                        if (ret.success) {
                            form.reset();
                            returnRequestQuote.innerText = calculoSelantesAdesivosParams.success;
                            setTimeout(function () {
                                window.location.href = calculoSelantesAdesivosParams.redirection;
                            }, 1000);
                        } else {
                            returnRequestQuote.innerText = calculoSelantesAdesivosParams.error;
                        }
                    }
                };
                request.send(self.urlEncoded(data));
            };

            window.addEventListener('load', () => {
                const form = document.getElementById('calculoSelantesAdesivos');
                new CalculoSelantesAdesivosForm(form);
            });
        }(window, document));

    }

}

export default CalcSelantesAdesivos;